<template>
    <b-tooltip label="complete"
    type="is-success"
    position="is-bottom" square>
        <button  style="border: 0px; background: none"
            v-on:click="$emit('complete', row_data)" class="button is-small is">
            <span>
                <b-icon type="is-success" pack="fas" icon="check-circle"></b-icon>
            </span>
        </button>                                                         
    </b-tooltip>
</template>

<script>
export default {
    props: ["row_data"],
}
</script>
